import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import * as $app from 'modules/app';

import { onboardingStepsReducer } from './reducers/onboardingSteps';

const reducerBase = combineReducers({
  onboardingSteps: onboardingStepsReducer,
});

const reducer = (state, action) => {
  if (action.type === $app.reset().type) {
    state = undefined;
  }

  return reducerBase(state, action);
};

const persistConfig = {
  key: 'app',
  storage: storage,
  whitelist: ['onboardingSteps'],
};

export const appReducer = persistReducer(persistConfig, reducer);
